export const Validity = {
  DEFAULT: 'default',
  VALID: 'valid',
  INVALID: 'invalid',
};

export const KUZA_INPUT_FIELDS_MAX_WIDTH = '645px';
